import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  Modal
} from "react-bootstrap";

import AuthenContext from "../models/AuthenContext";
import ButtonLoading from "../components/Controls/ButtonLoading";
import Page from "../components/Controls/Page";

function ChoiceGroup(props) {
  const history = useHistory();

  const {authen, setIsLogin} = useContext(AuthenContext);

  const [showForm, setShowForm] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formTitle, setFormTitle] = useState("");

  const [alert, setAlert] = useState({
    "show": false,
    "text": ""
  });

  const [confirm, setConfirm] = useState({
    "show": false,
    "text": "",
    "confirmBtnText": "",
    "onConfirm": () => {},
    "cancelBtnText": "",
    "onCancel": () => {}
  });

  const [search, setSearch] = useState({
    "keyword": ""
  });

  const handleSearchInputChange = (e) => {
    setSearch({
      ...search,
      [e.target.name]: e.target.value
    });

    setPages({
      ...pages,
      "activePage": 1
    });
  }

  const initForm = {
    "choice_id": "",
    "choice_name": "",
  };

  let activePage = new URLSearchParams(props.location.search).get("page");
  activePage = activePage === null ? 1 : parseInt(activePage);

  const [locationKeys, setLocationKeys] = useState([]);
  const [table, setTable] = useState([]);
  const [pages, setPages] = useState({
    "activePage": activePage
  });

  const handlePageChange = (e, page) => {
    history.push("?page=" + page);
  }

  const [form, setForm] = useState(initForm);
  const [loadingSave, setLoadingSave] = useState(false);

  useEffect(() => {
    loadTable();
  }, [search, pages.activePage]);

  useEffect(() => {
    setPages({
      ...pages,
      "activePage": activePage
    });

    return history.listen(location => {
      if(history.action === "PUSH") {
        setLocationKeys([location.key]);
      }
  
      if(history.action === "POP") {
        if(locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
          // Handle forward event
        }
        else {
          setLocationKeys((keys) => [location.key, ...keys]);
          // Handle back event
        }
      }
    });
  }, [locationKeys]);

  const handleFormInputChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  }

  const loadTable = () => {
    axios.post(process.env.REACT_APP_API_URL + "/school/choice.list", {
      "api_key": process.env.REACT_APP_API_KEY,
      "token": authen.token,
      "keyword": search.keyword,
      "page": pages.activePage
    })
    .then((res) => {
      let { status, data, page } = res.data;
      if(status == 1) {
        setPages(page);
        setTable(data.map((row) => {
          return {...row, loadingEdit: false, loadingDelete: false};
        }));
      }
      else if(status == -1) {
        setIsLogin(false);
      }
      else {
        setAlert({
          "show": true,
          "text": res.data.msg
        });
      }
    })
    .catch((ex) => {
      console.log(ex);
      setAlert({
        "show": true,
        "text": process.env.REACT_APP_SERVER_NOT_CONNECT
      });
    });
  }

  const loadEdit = (index) => {
    let id = table[index].id;
    
    axios.post(process.env.REACT_APP_API_URL + "/school/choice.get", {
      "api_key": process.env.REACT_APP_API_KEY,
      "token": authen.token,
      "id": id
    })
    .then((res) => {
      let { status, data } = res.data;
      if(status == 1) {
        setForm(data);
        setValidated(false);
        setFormTitle("แก้ไขรูปแบบ");
        setShowForm(true);
      }
      else if(status == -1) {
        setIsLogin(false);
      }
      else {
        setAlert({
          "show": true,
          "text": res.data.msg
        });
      }
    })
    .catch((ex) => {
      console.log(ex);
      setAlert({
        "show": true,
        "text": process.env.REACT_APP_SERVER_NOT_CONNECT
      });
    })
    .finally(() => {
      table[index].loadingEdit = false;
    });
  }

  const addData = (e) => {
    setForm(initForm);
    setValidated(false);
    setFormTitle("เพิ่มรูปแบบ");
    setShowForm(true);
  }

  const editData = (e, index) => {
    e.preventDefault();
    table[index].loadingEdit = true;
    loadEdit(index);
  }

  const deleteData = (e, index) => {
    e.preventDefault();
    table[index].loadingDelete = true;
    setConfirm({
      "show": true,
      "text": `ต้องการลบ "${table[index].choice_name}" ใช่หรือไม่`,
      "confirmBtnText": "ลบ",
      "onConfirm": () => {
        let id = table[index].id;

        axios.post(process.env.REACT_APP_API_URL + "/school/choice.delete", {
          "api_key": process.env.REACT_APP_API_KEY,
          "token": authen.token,
          "id": id
        })
        .then((res) => {
          let { status, data } = res.data;
          if(status == 1) {
            loadTable();
          }
          else if(status == -1) {
            setIsLogin(false);
          }
          else {
            setAlert({
              "show": true,
              "text": res.data.msg
            });
          }
        })
        .catch((ex) => {
          console.log(ex);
          setAlert({
            "show": true,
            "text": process.env.REACT_APP_SERVER_NOT_CONNECT
          });
        })
        .finally(() => {
          table[index].loadingDelete = false;
        });

        setConfirm({"show": false});
      },
      "cancelBtnText": "ยกเลิก",
      "onCancel": () => {
        setConfirm({"show": false});
        table[index].loadingDelete = false;
      }
    });
  }

  const formSubmit = (e) => {
    e.preventDefault();

    let is_valid = false;
    if(e.currentTarget.checkValidity() === false) {
      is_valid = false;
      e.stopPropagation();
    }
    else {
      is_valid = true;
    }

    setValidated(true);

    if(is_valid) {
      setLoadingSave(true);

      axios.post(process.env.REACT_APP_API_URL + "/school/choice.set", {
        "api_key": process.env.REACT_APP_API_KEY,
        "token": authen.token,
        ...form
      })
      .then((res) => {
        let { status, data } = res.data;
        if(status == 1) {
          loadTable();
          setShowForm(false);
        }
        else {
          setAlert({
            "show": true,
            "text": res.data.msg
          });
        }
      })
      .catch((ex) => {
        console.log(ex);
      })
      .finally(() => {
        setLoadingSave(false);
      });
    }
  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Row>
                  <Col md="6">
                    <Form inline>
                      <Form.Group>
                        <Form.Label className="mr-sm-2">ค้นหา</Form.Label>
                        <Form.Control type="text" name="keyword" value={search.keyword} placeholder="ค้นหา" onChange={handleSearchInputChange}></Form.Control>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md="6">
                    <Button type="button" variant="info" className="btn-fill float-right" onClick={addData}><i className="fas fa-plus"></i> เพิ่มรูปแบบ</Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th width="80">ลำดับ</th>
                      <th>รูปแบบ</th>
                      <th width="120"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {table.map((row, index) => (
                      <tr key={index}>
                        <td className="text-center">{row.no}</td>
                        <td>{row.choice_name}</td>
                        <td className="text-center btn-manage-group">
                          <ButtonLoading type="link" icon="fas fa-pen" className="btn-manage" loading={row.loadingEdit} onClick={e => editData(e, index)}>แก้ไข</ButtonLoading>
                          <ButtonLoading type="link" icon="fas fa-times" className="btn-manage" loading={row.loadingDelete} onClick={e => deleteData(e, index)}>ลบ</ButtonLoading>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Page {...pages} onClick={handlePageChange} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        size="lg"
        backdrop="static"
        show={showForm}
        onHide={() => setShowForm(false)}
      >
        <Form noValidate validated={validated} onSubmit={formSubmit}>
          <Modal.Header className="justify-content-center">
            <Modal.Title>{formTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row}>
              <Form.Label column sm="2">รูปแบบ</Form.Label>
              <Col sm="10">
                <Form.Control type="text" name="choice_name" value={form.choice_name} onChange={handleFormInputChange} required></Form.Control>
                <Form.Control.Feedback type="invalid">กรุณาป้อน รูปแบบ</Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <ButtonLoading type="submit" icon="fas fa-check" className="btn btn-primary btn-fill mr-sm-2" loading={loadingSave}>บันทึก</ButtonLoading>
            <Button type="button" variant="default" className="btn-fill" onClick={() => setShowForm(false)}><i className="fas fa-times"></i> ปิด</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {
        alert.show && <SweetAlert
                        title={alert.text}
                        onConfirm={() => setAlert({"show": false})}
                        btnSize="md"
                        confirmBtnBsStyle="info"
                        confirmBtnCssClass="btn-fill"
                        confirmBtnStyle={{"border":"none","boxShadow":"none"}} />
      }
      {
        confirm.show && <SweetAlert
                        title={confirm.text}
                        btnSize="md"
                        onConfirm={confirm.onConfirm}
                        confirmBtnText={confirm.confirmBtnText}
                        confirmBtnBsStyle="info"
                        confirmBtnCssClass="btn-fill"
                        confirmBtnStyle={{"border":"none","boxShadow":"none"}}
                        showCancel={true}
                        onCancel={confirm.onCancel}
                        cancelBtnText={confirm.cancelBtnText}
                        cancelBtnBsStyle="default"
                        cancelBtnCssClass="btn-fill"
                        cancelBtnStyle={{"border":"none","boxShadow":"none"}} />
      }
    </>
  );
}

export default ChoiceGroup;
